// DORA Offcanvas helper
// Gestisce apertura/chiusura menu-drawer e cart-notification aggiungendo classe html.offcanvas-open
// Include fix per browser senza :has()
(function(){
  function toggleRoot(flag){
    document.documentElement.classList.toggle('offcanvas-open', !!flag);
  }
  const menuDrawer = document.querySelector('menu-drawer');
  const cartNotif = document.querySelector('cart-notification, .cart-notification, #cart-notification');

  if(menuDrawer){
    const observerMenu = new MutationObserver(()=>{
      const opened = menuDrawer.hasAttribute('open') || menuDrawer.getAttribute('data-open') === 'true' || menuDrawer.classList.contains('is-open');
      toggleRoot(opened || isCartActive());
    });
    observerMenu.observe(menuDrawer, {attributes:true, attributeFilter:['open','data-open','class']});
  }

  function isCartActive(){
    if(!cartNotif) return false;
    return cartNotif.classList.contains('active') || cartNotif.hasAttribute('open') || cartNotif.getAttribute('aria-modal') === 'true';
  }

  if(cartNotif){
    const target = cartNotif.closest('cart-notification') || cartNotif;
    const observerCart = new MutationObserver(()=>{
      toggleRoot(isCartActive() || isMenuOpen());
    });
    observerCart.observe(target, {attributes:true, attributeFilter:['class','open','aria-modal']});
  }

  function isMenuOpen(){
    if(!menuDrawer) return false;
    return menuDrawer.hasAttribute('open') || menuDrawer.getAttribute('data-open') === 'true' || menuDrawer.classList.contains('is-open');
  }

  // Chiudi offcanvas-open quando clic su elementi con data-dismiss-offcanvas
  document.addEventListener('click', (e)=>{
    const el = e.target.closest('[data-dismiss-offcanvas]');
    if(el){ toggleRoot(false); }
  });

  // Safety: rimuovi classe se nessun offcanvas attivo dopo resize
  window.addEventListener('resize', ()=>{
    if(!isMenuOpen() && !isCartActive()) toggleRoot(false);
  });
})();
